import 'firebase/compat/auth';
import 'firebase/compat/storage';
import firebase from 'firebase/compat/app';
import { SongId } from "../models/Song";
import { OwnerId } from "../models/User";
import { toDateSeconds, uuidv4 } from "../util/sugar";
import { ArtistService } from "./ArtistService";


export class TransmissionService {

  static FetchTodaysTransmission = (ownerId: OwnerId) => {
    return new Promise<SongId | null>((resolve, reject) => {
      ArtistService.fetchLatestSong(ownerId).then((song) => {
        const today = new Date().setHours(0, 0, 0, 0);
        const thatDay = new Date(toDateSeconds(song.updatedAt)).setHours(0, 0, 0, 0);
        if (today === thatDay) {
          resolve(song.id);
        } else {
          resolve(null);
        }
      }).catch(reject);
    });
  }

  // Image uploads (avatars, covers, wall images, song art) go to this
  // instance's Firebase Storage bucket, same as song audio. They used to be
  // POSTed to S3 with an AWS access key and a long-lived upload policy
  // hardcoded in the client bundle (UMich scan finding "Third-Party Service
  // Secret Disclosure"). Existing S3 URLs stored on docs keep working.
  static UploadImage = async (collection: string, file: File): Promise<string> => {
    const uid = firebase.auth().currentUser?.uid;
    if (!uid) {
      throw new Error("Must be signed in to upload");
    }
    const extension = (file.name.split(".").pop() || "").toLowerCase();
    const suffix = file.name.includes(".") && /^[a-z0-9]{1,10}$/.test(extension) ? `.${extension}` : "";
    const ref = firebase.storage().ref(`${collection}/${uid}/${uuidv4()}${suffix}`);
    await ref.put(file, { contentType: file.type });
    return ref.getDownloadURL();
  }

}
